import {
  HERO_SCHEDULE,
  INTEREST_SCHEDULE,
  LATEST_SCHEDULE,
  POPULAR_SCHEDULE,
} from '@pages/Root/pages/HomeRoot/constants.ts';
import { API_URL, DEFAULT_CKEY, getInitializedMomentFetcher } from '@moment/net/fetch-contstants.ts';
import { resolvedLanguage } from '@/i18n.ts';
import { IDailyLookBookResponce } from '@pages/Root/services/api/lookBook/lookbook-model-definitions.ts';

export interface IHomePageData {
  heroSchedule: IDailyLookBookResponce;
  interestSchedule: IDailyLookBookResponce;
  latestSchedule: IDailyLookBookResponce;
  popularSchedule: IDailyLookBookResponce;
}

export const HOME_QUERY_KEYS = {
  hero: ['home', 'hero'],
  interest: ['home', 'interest'],
  latest: ['home', 'latest'],
  popular: ['home', 'popular'],
}

/**
 * A generic function to fetch data for a single schedule.
 * This will be the `queryFn` for our individual useQuery hooks.
 */
export const fetchSchedule = (paramsOuter?: any, schedule: string) => {
  return async (params?: { lang?: string }) => {
    const language = params?.lang || paramsOuter?.lang || resolvedLanguage('en');
    const momentFetcher = await getInitializedMomentFetcher();
    const url = `${API_URL}/wp/v1/daily?ckey=${DEFAULT_CKEY}&sched=${schedule}&mp_lang=${language}&previewAspect=all`;
    const rawResponse = await momentFetcher.fetch(url);
    return (await rawResponse.json()) as IDailyLookBookResponce;
  }
};

/**
 * A dedicated function for pre-fetching all home page data on the server.
 * This function will be called from your SSR entrypoint.
 */

const travelSchedule = INTEREST_SCHEDULE.NZf7cr;

export const fetchDefinitions = [

  {
    queryKey: HOME_QUERY_KEYS.hero,
    queryFn: (params) => { return fetchSchedule(params, HERO_SCHEDULE)},
  },
  {
    queryKey: HOME_QUERY_KEYS.interest,
    queryFn: (params) => { return fetchSchedule(params, travelSchedule)},
  },

  {
    queryKey: HOME_QUERY_KEYS.latest,
    queryFn: (params) => { return fetchSchedule(params, LATEST_SCHEDULE)},
  },
  {
    queryKey: HOME_QUERY_KEYS.popular,
    queryFn: (params) => { return fetchSchedule(params, POPULAR_SCHEDULE)},
  },
];
